// extracted by mini-css-extract-plugin
export default {"DoctorsNote":"styles_DoctorsNote__mBaWQ","header":"styles_header__HsCXb"};